export default {
    availableonTitle: "Available on",
    availableonPart: `
    Enjoy exclusive and premium content in high quality 
    via any electronic device available to you from the list below
    `,
};